/** Returns true when a query/mutation error is an HTTP 404 (resource not found). */
export function isNotFoundError(error) {
  var _response;
  var status = error === null || error === void 0 || (_response = error.response) === null || _response === void 0 ? void 0 : _response.status;
  return status === 404;
}